import { z } from 'zod';
import { changePasswordSchema } from '@fenix/shared';

/** Schema do formulário de troca de senha: o da API + confirmação. */
export const passwordFormSchema = changePasswordSchema
  .extend({ confirmPassword: z.string() })
  .refine((v) => v.newPassword === v.confirmPassword, {
    path: ['confirmPassword'],
    message: 'As senhas não conferem',
  });

export const EMPTY_PASSWORD_FORM = { currentPassword: '', newPassword: '', confirmPassword: '' };
